import { render, staticRenderFns } from "./MissedCallsBanner.vue?vue&type=template&id=039161f8&scoped=true"
import script from "./MissedCallsBanner.vue?vue&type=script&lang=js"
export * from "./MissedCallsBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039161f8",
  null
  
)

export default component.exports